// extracted by mini-css-extract-plugin
export var VisitSpecificGroupBookings = "VisitSpecificGroupBookings-module--VisitSpecificGroupBookings--fe343";
export var image = "VisitSpecificGroupBookings-module--image--f1646";
export var textContent = "VisitSpecificGroupBookings-module--textContent--b47be";